import React, { useEffect, useState, lazy, Component } from 'react';
import { CheckCircle2, Clock, Calendar, AlertCircle, Check } from 'lucide-react';
export function OfferSection() {
  const [formData, setFormData] = useState({
    nombre: '',
    telefono: '',
    email: '',
    tipo_obra: '',
    ubicacion: '',
    presupuesto_estimado: ''
  });
  const [customTipoObra, setCustomTipoObra] = useState('');
  const [showCustomTipoObra, setShowCustomTipoObra] = useState(false);
  const [departamento, setDepartamento] = useState('');
  const [ciudad, setCiudad] = useState('');
  const [showCustomUbicacion, setShowCustomUbicacion] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [error, setError] = useState('');
  const [timeLeft, setTimeLeft] = useState(10 * 60); // 10 minutes in seconds
  // Countdown timer effect
  useEffect(() => {
    if (timeLeft <= 0) return;
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, [timeLeft]);
  // Format time as MM:SS
  const formatTime = (seconds: number) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  };
  const handleVirtualWhatsApp = () => {
    const message = encodeURIComponent('Hola, Seleccionar Asesoría Virtual');
    window.open(`https://wa.me/573182434499?text=${message}`, '_blank');
  };
  const handlePresencialWhatsApp = () => {
    const message = encodeURIComponent('Hola, Seleccionar Asesoría Presencial');
    window.open(`https://wa.me/573182434499?text=${message}`, '_blank');
  };
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setIsSubmitting(true);
    // Build ubicacion value based on selection
    let ubicacionValue = formData.ubicacion;
    if (formData.ubicacion === 'Otro') {
      ubicacionValue = `${departamento}, ${ciudad}`;
    }
    // Use custom tipo_obra text if "Otro" was selected
    const dataToSend = {
      ...formData,
      tipo_obra: formData.tipo_obra === 'Otro' ? customTipoObra : formData.tipo_obra,
      ubicacion: ubicacionValue
    };
    try {
      const response = await fetch('https://script.google.com/macros/s/AKfycbxQ700fda89uw4D9mKFnaPHHDUGZRbO5V41RXEE6rxOVeoCVE88GRNb8qXHwR4OdjMr/exec', {
        method: 'POST',
        headers: {
          'Content-Type': 'text/plain'
        },
        body: JSON.stringify(dataToSend)
      });
      if (response.ok) {
        // Track Lead event on successful form submission
        if (window.fbq) {
          window.fbq('track', 'Lead');
        }
        setIsSuccess(true);
      } else {
        throw new Error('Error en el envío');
      }
    } catch (err) {
      setError('Hubo un error, intenta de nuevo o llámanos al +57 (318) 243 4499');
    } finally {
      setIsSubmitting(false);
    }
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const {
      name,
      value
    } = e.target;
    if (name === 'tipo_obra') {
      setShowCustomTipoObra(value === 'Otro');
      if (value !== 'Otro') {
        setCustomTipoObra('');
      }
    }
    if (name === 'ubicacion') {
      setShowCustomUbicacion(value === 'Otro');
      if (value !== 'Otro') {
        setDepartamento('');
        setCiudad('');
      }
    }
    setFormData({
      ...formData,
      [name]: value
    });
  };
  const handleAgendarWhatsApp = () => {
    window.open('https://wa.me/573182434499?text=%C2%A1Hola!%2C%20quiero%20agendar%20mi%20asesor%C3%ADa%20gratis%20el%20dia%20___%20a%20las%20___', '_blank');
  };
  return <section id="offer" className="bg-white py-12 md:py-20" style={{
    contentVisibility: 'auto'
  }} data-id="element-118">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6" data-id="element-119">
        <div className="max-w-2xl mx-auto mb-8 md:mb-16" data-id="element-120">
          <div className="bg-[#E8621A]/5 border-2 border-[#E8621A] rounded-2xl p-6 md:p-8" data-id="element-121">
            <div className="flex flex-col items-center text-center" data-id="element-122">
              <AlertCircle className="w-12 h-12 md:w-14 md:h-14 text-[#E8621A] mb-4" data-id="element-123" />
              <h2 className="text-[26px] md:text-[32px] font-bold text-[#1A1A1A] mb-2" style={{
              fontFamily: 'Montserrat, sans-serif',
              lineHeight: '1.2'
            }} data-id="element-124">
                Empieza por aquí
              </h2>
              <h3 className="text-[18px] md:text-[20px] font-semibold text-[#1A1A1A] mb-6" style={{
              fontFamily: 'Montserrat, sans-serif',
              lineHeight: '1.3'
            }} data-id="element-125">
                ⏰ Oferta por Tiempo Limitado
              </h3>

              {/* Countdown Timer */}
              <div className="bg-[#E8621A] text-white px-4 py-2 rounded-lg mb-6" data-id="element-126">
                <div className="text-[11px] md:text-[12px] font-semibold uppercase mb-1" style={{
                letterSpacing: '0.05em'
              }} data-id="element-127">
                  Oferta expira en:
                </div>
                <div className="text-[24px] md:text-[28px] font-black" style={{
                fontFamily: 'Montserrat, sans-serif'
              }} data-id="element-128">
                  {formatTime(timeLeft)}
                </div>
              </div>

              {/* Orange divider */}
              <div className="w-full h-px bg-[#E8621A] mb-8" data-id="element-129"></div>

              {/* Contact Form integrated inside */}
              <div className="w-full" data-id="element-130">
                <h2 className="text-[22px] md:text-[28px] font-bold text-[#1A1A1A] mb-6" style={{
                lineHeight: '1.2',
                letterSpacing: '-0.02em'
              }} data-id="element-131">
                  Solicita tu asesoría gratuita
                </h2>

                {!isSuccess ? <form onSubmit={handleSubmit} className="w-full" data-id="element-132">
                    {/* Nombre completo */}
                    <div className="md:col-span-1" data-id="element-133">
                      <label htmlFor="nombre" className="block text-[14px] font-semibold text-[#2C2C2C] mb-2" style={{
                    fontFamily: 'Montserrat, sans-serif'
                  }} data-id="element-134">
                        Nombre completo
                      </label>
                      <input type="text" id="nombre" name="nombre" autoComplete="name" required value={formData.nombre} onChange={handleChange} placeholder="Tu nombre completo" className="w-full px-3 py-3 border border-[#D1D5DB] rounded-lg text-[15px] text-[#2C2C2C] placeholder:text-[#9CA3AF] focus:outline-none focus:ring-2 focus:ring-[#E8621A] focus:ring-offset-2" style={{
                    fontFamily: 'Open Sans, sans-serif',
                    minHeight: '48px'
                  }} data-id="element-135" />
                    </div>

                    {/* Teléfono */}
                    <div className="md:col-span-1" data-id="element-136">
                      <label htmlFor="telefono" className="block text-[14px] font-semibold text-[#2C2C2C] mb-2" style={{
                    fontFamily: 'Montserrat, sans-serif'
                  }} data-id="element-137">
                        Teléfono
                      </label>
                      <input type="tel" id="telefono" name="telefono" autoComplete="tel" required value={formData.telefono} onChange={handleChange} placeholder="300 123 4567" className="w-full px-3 py-3 border border-[#D1D5DB] rounded-lg text-[15px] text-[#2C2C2C] placeholder:text-[#9CA3AF] focus:outline-none focus:ring-2 focus:ring-[#E8621A] focus:ring-offset-2" style={{
                    fontFamily: 'Open Sans, sans-serif',
                    minHeight: '48px'
                  }} data-id="element-138" />
                    </div>

                    {/* Email */}
                    <div className="md:col-span-1" data-id="element-139">
                      <label htmlFor="email" className="block text-[14px] font-semibold text-[#2C2C2C] mb-2" style={{
                    fontFamily: 'Montserrat, sans-serif'
                  }} data-id="element-140">
                        Email
                      </label>
                      <input type="email" id="email" name="email" autoComplete="email" required value={formData.email} onChange={handleChange} placeholder="tucorreo@email.com" className="w-full px-3 py-3 border border-[#D1D5DB] rounded-lg text-[15px] text-[#2C2C2C] placeholder:text-[#9CA3AF] focus:outline-none focus:ring-2 focus:ring-[#E8621A] focus:ring-offset-2" style={{
                    fontFamily: 'Open Sans, sans-serif',
                    minHeight: '48px'
                  }} data-id="element-141" />
                    </div>

                    {/* Tipo de obra */}
                    <div className="md:col-span-1" data-id="element-142">
                      <label htmlFor="tipo_obra" className="block text-[14px] font-semibold text-[#2C2C2C] mb-2" style={{
                    fontFamily: 'Montserrat, sans-serif'
                  }} data-id="element-143">
                        Tipo de obra
                      </label>
                      <select id="tipo_obra" name="tipo_obra" required value={formData.tipo_obra} onChange={handleChange} className="w-full px-3 py-3 border border-[#D1D5DB] rounded-lg text-[15px] text-[#2C2C2C] focus:outline-none focus:ring-2 focus:ring-[#E8621A] focus:ring-offset-2" style={{
                    fontFamily: 'Open Sans, sans-serif',
                    minHeight: '48px'
                  }} data-id="element-144">
                        <option value="" disabled data-id="element-145">
                          Selecciona el tipo de obra
                        </option>
                        <option value="Construcción nueva" data-id="element-146">
                          Construcción nueva
                        </option>
                        <option value="Remodelación" data-id="element-147">Remodelación</option>
                        <option value="Ampliación" data-id="element-148">Ampliación</option>
                        <option value="Mantenimiento" data-id="element-149">Mantenimiento</option>
                        <option value="Otro" data-id="element-150">Otro</option>
                      </select>
                    </div>

                    {showCustomTipoObra && <div className="md:col-span-2 transition-all duration-300 ease-in-out" data-id="element-151">
                        <input type="text" id="custom_tipo_obra" name="custom_tipo_obra" required value={customTipoObra} onChange={e => setCustomTipoObra(e.target.value)} placeholder="Describe el tipo de obra" className="w-full px-3 py-3 border border-[#D1D5DB] rounded-lg text-[15px] text-[#2C2C2C] placeholder:text-[#9CA3AF] focus:outline-none focus:ring-2 focus:ring-[#E8621A] focus:ring-offset-2" style={{
                    fontFamily: 'Open Sans, sans-serif',
                    minHeight: '48px'
                  }} data-id="element-152" />
                      </div>}
                    {/* Ubicación aproximada */}
                    <div className="md:col-span-1" data-id="element-153">
                      <label htmlFor="ubicacion" className="block text-[14px] font-semibold text-[#2C2C2C] mb-2" style={{
                    fontFamily: 'Montserrat, sans-serif'
                  }} data-id="element-154">
                        Ubicación aproximada
                      </label>
                      <select id="ubicacion" name="ubicacion" required value={formData.ubicacion} onChange={handleChange} className="w-full px-3 py-3 border border-[#D1D5DB] rounded-lg text-[15px] text-[#2C2C2C] focus:outline-none focus:ring-2 focus:ring-[#E8621A] focus:ring-offset-2" style={{
                    fontFamily: 'Open Sans, sans-serif',
                    minHeight: '48px'
                  }} data-id="element-155">
                        <option value="" disabled data-id="element-156">
                          Selecciona tu ubicación
                        </option>
                        <option value="Bucaramanga" data-id="element-157">Bucaramanga</option>
                        <option value="Floridablanca" data-id="element-158">Floridablanca</option>
                        <option value="Piedecuesta" data-id="element-159">Piedecuesta</option>
                        <option value="Girón" data-id="element-160">Girón</option>
                        <option value="Otro" data-id="element-161">Otro</option>
                      </select>
                    </div>

                    {showCustomUbicacion && <>
                        {/* Departamento */}
                        <div className="md:col-span-1 transition-all duration-300 ease-in-out" data-id="element-162">
                          <label htmlFor="departamento" className="block text-[14px] font-semibold text-[#2C2C2C] mb-2" style={{
                      fontFamily: 'Montserrat, sans-serif'
                    }} data-id="element-163">
                            Departamento
                          </label>
                          <select id="departamento" name="departamento" required value={departamento} onChange={e => setDepartamento(e.target.value)} className="w-full px-3 py-3 border border-[#D1D5DB] rounded-lg text-[15px] text-[#2C2C2C] focus:outline-none focus:ring-2 focus:ring-[#E8621A] focus:ring-offset-2" style={{
                      fontFamily: 'Open Sans, sans-serif',
                      minHeight: '48px'
                    }} data-id="element-164">
                            <option value="" disabled data-id="element-165">
                              Selecciona departamento
                            </option>
                            <option value="Amazonas" data-id="element-166">Amazonas</option>
                            <option value="Antioquia" data-id="element-167">Antioquia</option>
                            <option value="Arauca" data-id="element-168">Arauca</option>
                            <option value="Atlántico" data-id="element-169">Atlántico</option>
                            <option value="Bolívar" data-id="element-170">Bolívar</option>
                            <option value="Boyacá" data-id="element-171">Boyacá</option>
                            <option value="Caldas" data-id="element-172">Caldas</option>
                            <option value="Caquetá" data-id="element-173">Caquetá</option>
                            <option value="Casanare" data-id="element-174">Casanare</option>
                            <option value="Cauca" data-id="element-175">Cauca</option>
                            <option value="Cesar" data-id="element-176">Cesar</option>
                            <option value="Chocó" data-id="element-177">Chocó</option>
                            <option value="Córdoba" data-id="element-178">Córdoba</option>
                            <option value="Cundinamarca" data-id="element-179">Cundinamarca</option>
                            <option value="Guainía" data-id="element-180">Guainía</option>
                            <option value="Guaviare" data-id="element-181">Guaviare</option>
                            <option value="Huila" data-id="element-182">Huila</option>
                            <option value="La Guajira" data-id="element-183">La Guajira</option>
                            <option value="Magdalena" data-id="element-184">Magdalena</option>
                            <option value="Meta" data-id="element-185">Meta</option>
                            <option value="Nariño" data-id="element-186">Nariño</option>
                            <option value="Norte de Santander" data-id="element-187">
                              Norte de Santander
                            </option>
                            <option value="Putumayo" data-id="element-188">Putumayo</option>
                            <option value="Quindío" data-id="element-189">Quindío</option>
                            <option value="Risaralda" data-id="element-190">Risaralda</option>
                            <option value="San Andrés y Providencia" data-id="element-191">
                              San Andrés y Providencia
                            </option>
                            <option value="Santander" data-id="element-192">Santander</option>
                            <option value="Sucre" data-id="element-193">Sucre</option>
                            <option value="Tolima" data-id="element-194">Tolima</option>
                            <option value="Valle del Cauca" data-id="element-195">
                              Valle del Cauca
                            </option>
                            <option value="Vaupés" data-id="element-196">Vaupés</option>
                            <option value="Vichada" data-id="element-197">Vichada</option>
                          </select>
                        </div>

                        {/* Ciudad */}
                        <div className="md:col-span-1 transition-all duration-300 ease-in-out" data-id="element-198">
                          <label htmlFor="ciudad" className="block text-[14px] font-semibold text-[#2C2C2C] mb-2" style={{
                      fontFamily: 'Montserrat, sans-serif'
                    }} data-id="element-199">
                            Ciudad
                          </label>
                          <input type="text" id="ciudad" name="ciudad" required value={ciudad} onChange={e => setCiudad(e.target.value)} placeholder="Escribe tu ciudad" className="w-full px-3 py-3 border border-[#D1D5DB] rounded-lg text-[15px] text-[#2C2C2C] placeholder:text-[#9CA3AF] focus:outline-none focus:ring-2 focus:ring-[#E8621A] focus:ring-offset-2" style={{
                      fontFamily: 'Open Sans, sans-serif',
                      minHeight: '48px'
                    }} data-id="element-200" />
                        </div>
                      </>}
                    {/* Presupuesto estimado */}
                    <div className="md:col-span-1" data-id="element-201">
                      <label htmlFor="presupuesto_estimado" className="block text-[14px] font-semibold text-[#2C2C2C] mb-2" style={{
                    fontFamily: 'Montserrat, sans-serif'
                  }} data-id="element-202">
                        Presupuesto estimado
                      </label>
                      <select id="presupuesto_estimado" name="presupuesto_estimado" required value={formData.presupuesto_estimado} onChange={handleChange} className="w-full px-3 py-3 border border-[#D1D5DB] rounded-lg text-[15px] text-[#2C2C2C] focus:outline-none focus:ring-2 focus:ring-[#E8621A] focus:ring-offset-2" style={{
                    fontFamily: 'Open Sans, sans-serif',
                    minHeight: '48px'
                  }} data-id="element-203">
                        <option value="" disabled data-id="element-204">
                          Selecciona tu presupuesto
                        </option>
                        <option value="$5M - $20M COP" data-id="element-205">$5M - $20M COP</option>
                        <option value="$20M - $50M COP" data-id="element-206">$20M - $50M COP</option>
                        <option value="$50M - $100M COP" data-id="element-207">
                          $50M - $100M COP
                        </option>
                        <option value="$100M - $300M COP" data-id="element-208">
                          $100M - $300M COP
                        </option>
                        <option value="Más de $300M COP" data-id="element-209">
                          Más de $300M COP
                        </option>
                      </select>
                    </div>

                    {/* Submit Button */}
                    <div className="md:col-span-2" data-id="element-210">
                      <button type="submit" disabled={isSubmitting} className="w-full bg-[#E8621A] text-white px-7 py-3.5 rounded-lg font-bold text-[16px] hover:bg-[#D4570F] transition-colors disabled:opacity-50 disabled:cursor-not-allowed" style={{
                    fontFamily: 'Montserrat, sans-serif',
                    minHeight: '48px'
                  }} data-id="element-211">
                        {'Solicitar Asesor\xEDa gratuita'}
                      </button>

                      {/* Info below button */}
                      <div className="mt-4 space-y-2" data-id="element-212">
                        <div className="flex items-center justify-center gap-2 text-[13px] md:text-[14px]" data-id="element-213">
                          <Calendar className="w-4 h-4 text-[#E8621A]" data-id="element-214" />
                          <span className="font-medium text-[#1A1A1A]" data-id="element-215">
                            Válido hasta agotar disponibilidad
                          </span>
                        </div>
                        <div className="flex items-center justify-center gap-2 text-[13px] md:text-[14px]" data-id="element-216">
                          <Clock className="w-4 h-4 text-[#E8621A]" data-id="element-217" />
                          <span className="font-medium text-[#1A1A1A]" data-id="element-218">
                            Cupos disponible: 10 cupos
                          </span>
                        </div>
                      </div>
                    </div>
                  </form> : <div className="text-center py-8" data-id="element-219">
                    <div className="inline-flex items-center justify-center w-16 h-16 bg-green-100 rounded-full mb-4" data-id="element-220">
                      <Check className="w-8 h-8 text-green-600" data-id="element-221" />
                    </div>
                    <h3 className="text-[24px] font-bold text-[#1A1A1A] mb-2" style={{
                  fontFamily: 'Montserrat, sans-serif'
                }} data-id="element-222">
                      ¡Felicitaciones!
                    </h3>
                    <p className="text-[16px] font-normal text-[#2C2C2C] mb-5" style={{
                  fontFamily: 'Open Sans, sans-serif'
                }} data-id="element-223">
                      Solo falta un paso, agenda el día y la hora
                    </p>
                    <button onClick={handleAgendarWhatsApp} className="bg-[#E8621A] text-white px-7 py-3.5 rounded-lg font-bold text-[16px] hover:bg-[#D4570F] transition-colors" style={{
                  fontFamily: 'Montserrat, sans-serif',
                  minHeight: '48px'
                }} data-id="element-224">
                      Agendar GRATIS
                    </button>
                  </div>}
                {/* Error Message */}
                {error && <p className="mt-4 text-[14px] text-[#DC2626] text-center" style={{
                fontFamily: 'Open Sans, sans-serif'
              }} data-id="element-225">
                    {error}
                  </p>}
              </div>
            </div>
          </div>
        </div>
        <div className="grid md:grid-cols-2 gap-6 md:gap-8 mb-8 md:mb-12" data-id="element-226">
          {/* Left: Checklist */}
          <div className="space-y-4 md:space-y-6" data-id="element-227">
            <h3 className="text-[20px] md:text-[28px] font-semibold text-[#1A1A1A] mb-4 md:mb-6 text-center md:text-left" style={{
            lineHeight: '1.3'
          }} data-id="element-228">
              En una sola sesión puedes llegar a saber:
            </h3>
            <ul className="space-y-3 md:space-y-4" data-id="element-229">
              {['Qué tan viable es lo que tienes en mente', 'Qué errores evitar antes de gastar un peso', 'Cuánto podría costar de forma realista', 'Por dónde empezar si decides seguir adelante'].map((item, i) => <li key={i} className="flex items-start gap-2 md:gap-3" data-id="element-230">
                  <CheckCircle2 className="w-5 h-5 md:w-6 md:h-6 text-[#E8621A] flex-shrink-0 mt-0.5" data-id="element-231" />
                  <span className="text-[15px] md:text-[17px] text-[#1A1A1A]/80 font-normal" style={{
                lineHeight: '1.6'
              }} data-id="element-232">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>

          {/* Right: Reminder Card */}
          <div className="bg-[#E8621A]/5 border-2 border-[#E8621A] rounded-2xl md:rounded-3xl p-6 md:p-8" data-id="element-233">
            <AlertCircle className="w-10 h-10 md:w-12 md:h-12 text-[#E8621A] mb-3 md:mb-4 mx-auto md:mx-0" data-id="element-234" />

            <div className="space-y-3 md:space-y-4 mb-4 md:mb-6" data-id="element-235">
              <p className="text-[15px] md:text-[17px] text-[#1A1A1A]/70 font-normal text-center md:text-left" style={{
              lineHeight: '1.6'
            }} data-id="element-236">
                Aprovecha nuestra diligencia el formulario para agendar el día y
                la hora. Esta promoción especial se debe a nuestro lanzamiento
                digital.
              </p>
            </div>

            {/* APROVECHAR Button */}
            <button onClick={() => {
            const formSection = document.getElementById('offer');
            if (formSection) {
              formSection.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
              });
              // Focus on first form field after scroll
              setTimeout(() => {
                const firstInput = document.getElementById('nombre');
                if (firstInput) firstInput.focus();
              }, 500);
            }
          }} className="w-full bg-[#E8621A] text-white px-7 py-3.5 rounded-lg font-bold text-[16px] hover:bg-[#D4570F] transition-colors uppercase" style={{
            fontFamily: 'Montserrat, sans-serif',
            minHeight: '48px',
            letterSpacing: '0.05em'
          }} data-id="element-237">
              APROVECHAR
            </button>
          </div>
        </div>

        {/* Pricing Cards */}
        <div className="grid md:grid-cols-2 gap-6 md:gap-8" data-id="element-238">
          {/* Virtual Package */}

          {/* Presencial Package */}
        </div>

        {/* Gift Image */}
        <div className="w-full mt-8 md:mt-12" data-id="element-239"></div>
      </div>
    </section>;
}